import React, { useEffect, useState } from 'react'

import * as R from 'ramda'
import { Form, Segment } from 'semantic-ui-react'

import { Loader } from 'shared/components/Loader'
import PermissionCheckboxGroupContent from '.'

/**
 *
 * @param {object} props
 * @param {*[]} props.defaultPermissionAccesses
 * @param {function} props.onChange
 * @param {boolean} [props.loading]
 * @param {string} [props.searchText]
 * @param {object} [props.noDataMessage]
 */
export default function PermissionCheckboxGroup({
  defaultPermissionAccesses,
  onChange,
  loading,
  searchText,
  noDataMessage,
}) {
  const [permissionAccesses, setPermissionAccesses] = useState(defaultPermissionAccesses || [])
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (defaultPermissionAccesses) {
      setPermissionAccesses(defaultPermissionAccesses)
    }
  }, [defaultPermissionAccesses])

  if (loading) {
    return <Loader withContainer />
  }

  if (!defaultPermissionAccesses || defaultPermissionAccesses.length === 0) {
    return (
      <Form.Group grouped>
        <Segment>
          <Form.Field>{noDataMessage}</Form.Field>
        </Segment>
      </Form.Group>
    )
  }

  const _sortByName = R.sortBy(R.prop('name'))
  const filteredPermissionAccess = _sortByName(permissionAccesses).filter(({ name }) => {
    if (searchTerm) {
      return name.toLowerCase().includes(searchTerm.toLowerCase())
    }
    return true
  })

  function handleSearchChange(_, { value }) {
    setSearchTerm(value)
  }
  function selectAllOptions() {
    const selectAllPermissionAccess = permissionAccesses.map((data) => ({
      ...data,
      has_permission: true,
    }))
    onChangePermissionAccessAccesses(selectAllPermissionAccess)
  }
  function clearAllOptions() {
    const deselectAllPermissionAccess = permissionAccesses.map((data) => ({
      ...data,
      has_permission: false,
    }))
    onChangePermissionAccessAccesses(deselectAllPermissionAccess)
  }

  function onCheckboxChange(targetPermissionAccess) {
    const targetPermissionAccessIndex = permissionAccesses.findIndex(
      (item) => item.token === targetPermissionAccess.token
    )
    const updatedPermissionAccessAccess = R.assocPath(
      [targetPermissionAccessIndex, 'has_permission'],
      !targetPermissionAccess.has_permission,
      permissionAccesses
    )
    onChangePermissionAccessAccesses(updatedPermissionAccessAccess)
  }

  function onChangePermissionAccessAccesses(value) {
    setPermissionAccesses(value)
    onChange(value)
  }

  return (
    <PermissionCheckboxGroupContent
      permissionAccesses={filteredPermissionAccess}
      handleSearchChange={handleSearchChange}
      selectAllOptions={selectAllOptions}
      clearAllOptions={clearAllOptions}
      onCheckboxChange={onCheckboxChange}
      searchText={searchText}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/PermissionCheckboxGroup/container.js